import { APP_TENANTS } from "../../client/js/utils/AppConstants";

export enum ENV {
    STAGE,
    PROD,
    DEV
}

export enum AUTO_SAVE_MEDIUMS {
    SOCKET,
    HTTP
}

export const APP_STAGE = ENV.STAGE;

export const IS_DEV_ENV = true
export const ALBUS_API_PREFIX = "/albus";
export const POLARIS_API_PREFIX = "/polaris";
export const RAMSAY_API_PREFIX = "/ramsay";
export const MEAL_SERVICE_API_PREFIX = "/mealService";
export const GMF_API_PREFIX = "/gmf";
export const METRIC_SERVICE_API_PREFIX = "/metricService";
export const LOGGING_SERVICE_API_PREFIX = "/logging";
export const EHR_SERVICE_API_PREFIX = "/ehr";
export const OLLIVANDER_API_PREFIX = "/ollivander";
export const ORION_API_PREFIX = "/orion";
export const CONVERSE_API_PREFIX = "/converse-chat"
export const SUBUSER_API_PREFIX = "/subuser";
export const CARE_RECOMMENDATION_SERVICE_API_PREFIX = "/care-recommendation-service";
export const AWS_RES_PREFIX = "/aws/sig";

export const CONVERSE_API_TARGET = "http://127.0.0.1:3790";

export const ALBUS_API_ENDPOINT_PORT = "20000";
export const ALBUS_API_ENDPOINT_HOST = "http://127.0.0.1";

export const LOGGING_SERVICE_API_ENDPOINT_HOST = "http://logging.stage.curefit.co";
export const LOGGING_SERVICE_API_ENDPOINT_PORT = "80";

export const BYPASS_AUTHENTICATION_URLS = ["/orion/client/dummy/track"];
export const METRIC_SERVICE_API_ENDPOINT_HOST = "http://localhost";
export const METRIC_SERVICE_API_ENDPOINT_PORT = "20000";

export const POLARIS_API_ENDPOINT_HOST = "http://127.0.0.1:8181";
export const POLARIS_API_ENDPOINT_PORT = "8181";

export const RAMSAY_API_ENDPOINT_HOST = "http://ramsay.stage.curefit.co";
export const RAMSAY_API_ENDPOINT_PORT = "80";

export const MEAL_SERVICE_API_ENDPOINT_HOST = "http://reco-api.stage.curefit.co";
export const MEAL_SERVICE_API_ENDPOINT_PORT = "80";

export const GMF_API_ENDPOINT_HOST = "http://gms.stage.curefit.co";
export const GMF_API_ENDPOINT_PORT = "80";

export const CFS_API_ENDPOINT_HOST = "https://assessment.cure.fit";
export const CFS_API_ENDPOINT_PORT = "80";

export const EHR_API_ENDPOINT_HOST =
    // "http://ehr.stage.curefit.co";
    "https://ehr-stage.curefit.co";
// "http://127.0.0.1";
export const EHR_API_ENDPOINT_PORT =
    "80";
//  "38000";

export const OLLIVANDER_API_ENDPOINT_HOST =
    // "http://ollivander.stage.curefit.co";
    "https://ollivander-stage.curefit.co/";
// "http://127.0.0.1";
export const OLLIVANDER_API_ENDPOINT_PORT =
    "80";
// "36000";

export const SUBUSER_API_ENDPOINT_HOST =
    // "http://sub-user.stage.curefit.co";
    "https://sub-user-stage.curefit.co/";
// "http://127.0.0.1";
export const SUBUSER_API_ENDPOINT_PORT =
    "80";
// "35000";

export const CARE_RECOMMENDATION_SERVICE_API_ENDPOINT_HOST = "http://127.0.0.1";
export const CARE_RECOMMENDATION_SERVICE_API_ENDPOINT_PORT = "5687";

export const ALBUS_API_TARGET = ALBUS_API_ENDPOINT_HOST + ":" + ALBUS_API_ENDPOINT_PORT;
export const POLARIS_API_TARGET = POLARIS_API_ENDPOINT_HOST + ":" + POLARIS_API_ENDPOINT_PORT;
export const RAMSAY_API_TARGET = RAMSAY_API_ENDPOINT_HOST + ":" + RAMSAY_API_ENDPOINT_PORT;
export const GMF_API_TARGET = GMF_API_ENDPOINT_HOST + ":" + GMF_API_ENDPOINT_PORT;
export const METRIC_SERVICE_API_TARGET = "http://localhost:22000";
export const LOGGING_SERVICE_API_TARGET = LOGGING_SERVICE_API_ENDPOINT_HOST + ":" + LOGGING_SERVICE_API_ENDPOINT_PORT;
export const MEAL_SERVICE_API_TARGET = MEAL_SERVICE_API_ENDPOINT_HOST + ":" + MEAL_SERVICE_API_ENDPOINT_PORT;
export const EHR_SERVICE_API_TARGET = EHR_API_ENDPOINT_HOST; //+ ":" + EHR_API_ENDPOINT_PORT;
export const OLLIVANDER_SERVICE_API_TARGET = OLLIVANDER_API_ENDPOINT_HOST// + ":" + OLLIVANDER_API_ENDPOINT_PORT;
export const SUBUSER_SERVICE_API_TARGET = SUBUSER_API_ENDPOINT_HOST// + ":" + SUBUSER_API_ENDPOINT_PORT
export const CARE_RECOMMENDATION_SERVICE_API_TARGET = CARE_RECOMMENDATION_SERVICE_API_ENDPOINT_HOST + ":" + CARE_RECOMMENDATION_SERVICE_API_ENDPOINT_PORT;

export const MEAL_SERVICE_API_KEY = "J9oMSF42QNRCV0GAP0XiJ6Di8hAI7gfR";

export const REDIS_PREFIX = "CAREFIT-ORION-";
export const REDIS_HOST = "127.0.0.1";
export const REDIS_PORT = "6379";
export const REDIS_DB_INDEX = 0;


export const MAVERICK_API_PREFIX = "/maverick";
export const MAVERICK_HOST = "http://127.0.0.1";
export const MAVERICK_PORT = "35000";
export const MAVERICK_API_TARGET = MAVERICK_HOST + ":" + MAVERICK_PORT;

export const BYPASS_AUTHENTICATION = false;             // Should be false for PROD.
export const AUTH_URL_SUFFIX = "/auth/google";

export const PREFERRED_AUTO_SAVE_MEDIUM = AUTO_SAVE_MEDIUMS.HTTP;
export const WATCHMAN_URL = "https://watchmen.stage.curefit.co";
export const WATCHMAN_API_KEY = "orion-stage-access";
export const SSO_CALLBACK = "http://localhost:4000";
export const HTML_PDF_QUEUE = "stage-carefit-html-pdf";

export const CDN_URL = "https://d1yfs1c2pfwbpr.cloudfront.net";
export const ORION_IMG_URL = CDN_URL + "/image/carefit/orion/";
export const IRIS_API_PREFIX = "/iris";
export const IRIS_HOST = "http://iris.stage.curefit.co";

export const USER_FITNESS_PREFIX = "/user-fitness";
export const USER_FITNESS_HOST = "http://127.0.0.1";
export const USER_FITNESS_PORT = "5030";
export const USER_FITNESS_API_TARGET = USER_FITNESS_HOST + ":" + USER_FITNESS_PORT;

export const HERCULES_SERVICE_PREFIX = "/hercules";
export const HERCULES_SERVICE_HOST = "http://127.0.0.1";
export const HERCULES_SERVICE_PORT = "9009";
export const HERCULES_SERVICE_API_TARGET = HERCULES_SERVICE_HOST + ":" + HERCULES_SERVICE_PORT;

export const AUTOMATED_WORKING_HOURS_ALLOWED_AGENT_TYPES: string[] = ["DOCTOR", "LIFESTYLE_COACH", "MIND_THERAPIST"];

export const API_KEYS = {
    ALBUS: "f8870e147ab0f4686118aa83bddfbe88f0771236",
    HERCULES: 'p5UVcgNyrBeaQeUYbCxAMQ'
};

export const TENANT = APP_TENANTS.CAREFIT;
